import { Observable, of } from 'rxjs';

export class IsOptionValidValidator {
    public static Validate(control): Observable<any> {
        if (control.value && control.value !== '' && control.value !== -1 && control.value !== '-1') {
            return of(null);
        }
        return of({
            optionInvalid: true
        });
    }
}
